/* eslint-disable max-statements */
/* eslint-disable max-lines-per-function */
/* eslint-disable id-length */
// Libraries
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray, reduxForm } from 'redux-form';
import { compose, bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { last, first } from 'lodash';

// Component
import { FormElems, Alert, AlertModal } from '../../components/';

// Actions
import {
    showLoader,
    hideLoader,
} from '../../redux/common/loader/loader.actions';
import {
    saveAndContinueRequest,
    fetchDefaultRoutingRequest,
    resetSaveDataSuccessKey,
} from '../../containers/MerchantOnboard/redux/merchantOnBoard.actions';
import {
    fetchRouterDetailsRequest,
    updateRoutingDataRequest,
    addMerchantStepUpdateMakerRequest,
    resetUpdateDataSuccessKey,
} from '../../containers/MerchantOnboard/redux/editMerchant/editMerchant.actions';

// Helper Methods
import {
    isObjectEmpty,
    getDependentSectionName,
} from '../../utils/helperMethods';

// Constant
import { SUCCESS_MESSAGES } from '../../utils/constants/toastMessages';

// Validator
import warningIcon from '../../static/images/warning-icon.png';
import validate from './validator';

// Images

// Styles
import './routingTab.scss';
import { MAKER_CHECKER_EVENT_TYPES } from 'utils/constants/commonValues';

const paymentTypeNameMapping = {
    CC: 'Credit Card',
    DC: 'Debit Card',
    NB: 'Netbanking',
    WALLET: 'Wallet',
};

const RoutingTab = ({
    merchantData,
    actions,
    sectionType,
    name,
    formData,
    isEditMode,
    isViewMode,
    editData,
    data,
    nextPath,
    previousPath,
    history,
    handleSubmit,
    onBoardSteps,
    isInEditMode,
    dirty,
    change,
    auth,
}) => {
    const {
        saveData,
        formInProcess,
        uniqueIdentifier: { uniqueId },
        timeline: { fields },
    } = merchantData;


    const { updateData } = editData;
    const { location } = history;
    const currentStep = first(
        onBoardSteps.filter(item => item.sectionType === sectionType)
    );

    const [isShowModal, setIsShowModal] = useState(false);

    const onSuccessModal = () => {
        setIsShowModal(false);
        if (formData && formData.values) {
            handleFormSubmit(formData.values);
        }
    };

    const onCloseModal = () => {
        setIsShowModal(false);
    };

    const resetErrors = () => {
        if (isEditMode) {
            actions.resetUpdateDataSuccessKey();
        } else {
            actions.resetSaveDataSuccessKey();
        }
    };
    

    useEffect(() => {
        resetErrors();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isEditMode || isViewMode) {
            const merchantId = last(location.pathname.split('/'));
            actions.fetchRouterDetailsRequest(merchantId, fields);
        }
    }, [actions, fields, isEditMode, isViewMode, location.pathname]);

    useEffect(() => {
        let paymentModeDetails = [];
        const configuredPgs = [];
        console.log(formInProcess,"consoling in useeffect form in process")
        if (formInProcess.forms) {
            const paymentModeSection =
                formInProcess.forms[0] &&
                formInProcess.forms[0].sections.find(
                    section => section.type === 'paymentModeSection'
                );

            if (paymentModeSection) {
                paymentModeDetails = paymentModeSection.data.paymentModeDetails.filter(
                    item => item
                );
            }
            console.log(paymentModeSection,"consoling paymentModeSection")


            const pgConfigSection =
                formInProcess.forms[0] &&
                formInProcess.forms[0].sections.find(
                    section => section.type === 'pgConfigurationSection'
                );

            console.log(pgConfigSection,"consoling pgConfigSection")

            if (pgConfigSection) {
                const pgConfigs = Object.keys(pgConfigSection.data);
                console.log(pgConfigs,'consoling before pgConfigs');

                if (pgConfigs.includes('migsConfLive')) {
                    configuredPgs.push('migs');
                }
                if (pgConfigs.includes('ccAvenueConfLive')) {
                    configuredPgs.push('cca');
                }
                if (pgConfigs.includes('payuConfLive')) {
                    configuredPgs.push('payu');
                }
                if (pgConfigs.includes('cyberSourceConfLive')) {
                    configuredPgs.push('cybs');
                }
                if (pgConfigs.includes('hdfcConfLive')) {
                    configuredPgs.push('hdfc');
                }
                if (pgConfigs.includes('bdkLive')) {
                    configuredPgs.push('bdk');
                }
                if (pgConfigs.includes('fiservConfLive')) {
                    configuredPgs.push('fiserv');
                }
                if (pgConfigs.includes('mpgsConfLive')) {
                    configuredPgs.push('mpgs');
                }
                if (pgConfigs.includes('axisnbConfLive')) {
                    configuredPgs.push('axisnb');
                }
                if (pgConfigs.includes('wibmoConfLive')) {
                    configuredPgs.push('wibmo');
                }
            }
            console.log('axisnb is added to configuredPgs:', configuredPgs);
        }

        const request = {
            formIdentifier: uniqueId,
        };

        actions.fetchDefaultRoutingRequest(request);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [actions]);

    const getDynamicRoutingBoolValues = values => {
        const boolValues =
            values &&
            values.enableDynamicRouting &&
            Array.isArray(values.enableDynamicRouting) &&
            values.enableDynamicRouting.includes('enableDynamicRouting');
        return boolValues || false;
    };

    const handleFormSubmit = values => {
        if (
            currentStep &&
            currentStep.dependentSections &&
            currentStep.dependentSections.length &&
            currentStep.status === 'Complete' &&
            dirty &&
            !isShowModal
        ) {
            setIsShowModal(true);
        } else {
            const request = {
                uniqueIdentifier: uniqueId,
                sectionType,
                data: {
                    enableDynamicRouting: getDynamicRoutingBoolValues(values),
                    pgRoutingRequestList: values.pgRoutingRequestList.filter(
                        item => !isObjectEmpty(item.pgPercentage)
                    ),
                },
            };

            if (isEditMode) {
                const merchantId = last(location.pathname.split('/'));
                const updateRequest = {
                    entityCode: merchantId,
                    enableDynamicRouting: getDynamicRoutingBoolValues(values),
                    pgRoutingRequestList: values.pgRoutingRequestList.filter(
                        item => !isObjectEmpty(item.pgPercentage)
                    ),
                };
                const makerDetails = {
                    makerId: auth.userDetails.email || '',
                    idempotencyId: merchantId,
                    eventType: MAKER_CHECKER_EVENT_TYPES.ROUTING,
                };

                actions.addMerchantStepUpdateMakerRequest(
                    updateRequest,
                    sectionType,
                    makerDetails
                );
            } else if (isViewMode) {
                onNext();
            } else {
                actions.saveAndContinueRequest(request, sectionType);
            }
        }
    };
    const onNext = () => {
        resetErrors();
        history.push(nextPath);
    };
    const onBack = () => {
        resetErrors();
        history.push(previousPath);
    };

    useEffect(() => {
        if (saveData.isSuccess && saveData.sectionType === sectionType) {
            toast.info(SUCCESS_MESSAGES.SAVE_DATA(name));
            onNext();
        }
        return () => {
            if (saveData.isSuccess && saveData.sectionType === sectionType) {
                actions.resetSaveDataSuccessKey();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [saveData.isSuccess, saveData.sectionType]);

    useEffect(() => {
        if (updateData.isUpdated && updateData.sectionType === sectionType) {
            toast.info(SUCCESS_MESSAGES.UPDATE_MAKER_REQUEST_SUCCESS(name));
            onNext();
        }
        return () => {
            if (
                updateData.isUpdated &&
                updateData.sectionType === sectionType
            ) {
                actions.resetUpdateDataSuccessKey();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateData.isUpdated, updateData.sectionType]);

    const errorDetails = isEditMode ? updateData : saveData;
    const isOrAre = currentStep.dependentSections.length > 1 ? 'are' : 'is';
    return (
        <form
            className="routing-list-form"
            onSubmit={handleSubmit(handleFormSubmit)}
        >
            <div className="routing-tab card">
                <div className="title-section clearfix">
                    <h2 className="tab-title no-border">Routing</h2>
                    <div className="form-field dynamic-wrap">
                        <Field
                            name="enableDynamicRouting"
                            options={[
                                {
                                    label: 'Enable Dynamic Routing',
                                    value: 'enableDynamicRouting',
                                    checked: false,
                                },
                            ]}
                            valueField="value"
                            labelField="label"
                            component={FormElems.Checkbox}
                            isDisabled ={isViewMode}
                        />
                    </div>
                </div>
                {/* <RoutingTable /> */}
                {errorDetails.error && errorDetails.error.errorMessage ? (
                    <Alert customClass="error-msg">
                        {errorDetails.error.errorMessage}
                    </Alert>
                ) : null}
                <AlertModal
                    modalIsOpen={isShowModal}
                    closeModal={onCloseModal}
                    primaryButtonText="OK"
                    secondaryButtonText="CANCEL"
                    showActions={true}
                    currentSection={currentStep}
                    onSuccessModal={onSuccessModal}
                    message={`${getDependentSectionName(
                        onBoardSteps,
                        currentStep.dependentSections
                    )}
                    ${isOrAre} dependent on ${currentStep.name}
                    section. Please update dependent sections.`}
                />
                <div className="tableWrapper routing-table">
                    <table>
                        <thead>
                            <tr>
                                <th className="rolename">Payment Type</th>
                                <th className="username">Sub Type</th>
                                <th className="action">PG Percentage</th>
                            </tr>
                        </thead>
                        <tbody>
                            <FieldArray
                                name="pgRoutingRequestList"
                                component={renderRoutingRows}
                                props={{
                                    defaultRouting:
                                        formData.values.pgRoutingRequestList,
                                    isViewMode,
                                }}
                            />
                        </tbody>
                    </table>
                </div>
            </div>
            {!isViewMode &&(
                <>
            <div className="form-section action">
                <FormElems.Button
                    buttonType="secondary"
                    text="BACK"
                    type="button"
                    id="back-btn"
                    handleClick={onBack}
                    customClass="back-btn"
                />
                <FormElems.Button
                    id="next-btn"
                    buttonType="primary"
                    text="NEXT"
                />
            </div>
            </>
            )}
           
        </form>
    );
};

const renderRoutingRows = ({
    fields,
    meta: { error, submitFailed },
    defaultRouting,
    isViewMode,
}) => (
    <>
        {fields.length === 0 && (
            <tr>
                <td colSpan="3">
                    <div className="no-percent">
                        <img
                            className="warning-icon"
                            src={warningIcon}
                            alt=""
                        />
                        PGs are not configured for any payment type.
                    </div>
                </td>
            </tr>
        )}
        {fields.map((member, index) => (
            <tr>
                <td className="pay-type">
                    {paymentTypeNameMapping[defaultRouting[index].paymentType]}
                </td>
                <td className="pay-mode-info">
                    {defaultRouting[index].paymentModeInfoUI ||
                        defaultRouting[index].paymentModeInfo}
                </td>
                <td>
                    <ul className="userAction  multiItem">
                        {/* {console.log(defaultRouting[index] ,"consoling Default routing ")} */}
                        {isObjectEmpty(defaultRouting[index].pgPercentage) ? (
                            <div className="no-percent">
                                <img
                                    className="warning-icon"
                                    src={warningIcon}
                                    alt=""
                                />
                                PG is not configured for this payment type.
                            </div>
                        ) : (
                            ''
                        )}
                        {defaultRouting[index].pgPercentage.hasOwnProperty(
                            'payu'
                        ) && (
                            <li className="percent-option">
                                <span>Pay U</span>
                                <Field
                                    name={`${member}.pgPercentage.payu`}
                                    id={`${member}-pgPercentage-payu`}
                                    type="number"
                                    component={FormElems.Input}
                                    placeholder="%"
                                    min="0"
                                    max="100"
                                    postfixContent="%"
                                    disabled={isViewMode}
                                />
                            </li>
                        )}

{/*                         
                        { //axis nb field 
                        defaultRouting[index].pgPercentage.hasOwnProperty(
                            'axisnb'
                        ) && (
                            <li className="percent-option">
                                <span>Axis NB</span>
                                <Field
                                    name={`${member}.pgPercentage.axisnb`}
                                    id={`${member}-pgPercentage-axisnb`}
                                    type="number"
                                    component={FormElems.Input}
                                    placeholder="%"
                                    min="0"
                                    max="100"
                                    postfixContent="%"
                                    disabled={isViewMode}
                                />
                            </li>
                        )} */}

                        {defaultRouting[index].pgPercentage.hasOwnProperty(
                            'migs'
                        ) && (
                            <li className="percent-option">
                                <span>MIGS</span>
                                <Field
                                    name={`${member}.pgPercentage.migs`}
                                    id={`${member}-pgPercentage-migs`}
                                    type="number"
                                    component={FormElems.Input}
                                    placeholder="%"
                                    min="0"
                                    max="100"
                                    postfixContent="%"
                                    disabled={isViewMode}
                                />
                            </li>
                        )}
                        {defaultRouting[index].pgPercentage.hasOwnProperty(
                            'cca'
                        ) && (
                            <li className="percent-option">
                                <span>CC Avenue</span>
                                <Field
                                    name={`${member}.pgPercentage.cca`}
                                    id={`${member}-pgPercentage-cca`}
                                    type="number"
                                    component={FormElems.Input}
                                    placeholder="%"
                                    min="0"
                                    max="100"
                                    postfixContent="%"
                                    disabled={isViewMode}
                                />
                            </li>
                        )}
                        {defaultRouting[index].pgPercentage.hasOwnProperty(
                            'cybs'
                        ) && (
                            <li className="percent-option">
                                <span>Cyber Source</span>
                                <Field
                                    name={`${member}.pgPercentage.cybs`}
                                    id={`${member}-pgPercentage-cybs`}
                                    type="number"
                                    component={FormElems.Input}
                                    placeholder="%"
                                    min="0"
                                    max="100"
                                    postfixContent="%"
                                    disabled={isViewMode}
                                />
                            </li>
                        )}
                        {defaultRouting[index].pgPercentage.hasOwnProperty(
                            'hdfc'
                        ) && (
                            <li className="percent-option">
                                <span>HDFC</span>
                                <Field
                                    name={`${member}.pgPercentage.hdfc`}
                                    id={`${member}-pgPercentage-hdfc`}
                                    type="number"
                                    component={FormElems.Input}
                                    placeholder="%"
                                    min="0"
                                    max="100"
                                    postfixContent="%"
                                    disabled={isViewMode}
                                />
                            </li>
                        )}
                        {defaultRouting[index].pgPercentage.hasOwnProperty(
                            'bdk'
                        ) && (
                            <li className="percent-option">
                                <span>Bill Desk</span>
                                <Field
                                    name={`${member}.pgPercentage.bdk`}
                                    id={`${member}-pgPercentage-bdk`}
                                    type="number"
                                    component={FormElems.Input}
                                    placeholder="%"
                                    min="0"
                                    max="100"
                                    postfixContent="%"
                                    disabled={isViewMode}
                                />
                            </li>
                        )}
                        {defaultRouting[index].pgPercentage.hasOwnProperty(
                            'fiserv'
                        ) && (
                            <li className="percent-option">
                                <span>Fiserv</span>
                                <Field
                                    name={`${member}.pgPercentage.fiserv`}
                                    id={`${member}-pgPercentage-fiserv`}
                                    type="number"
                                    component={FormElems.Input}
                                    placeholder="%"
                                    min="0"
                                    max="100"
                                    postfixContent="%"
                                    disabled={isViewMode}
                                />
                            </li>
                        )}
                        {defaultRouting[index].pgPercentage.hasOwnProperty(
                            'mpgs'
                        ) && (
                            <li className="percent-option">
                                <span>MPGS</span>
                                <Field
                                    name={`${member}.pgPercentage.mpgs`}
                                    id={`${member}-pgPercentage-mpgs`}
                                    type="number"
                                    component={FormElems.Input}
                                    placeholder="%"
                                    min="0"
                                    max="100"
                                    postfixContent="%"
                                    disabled={isViewMode}
                                />
                            </li>
                        )}
                        {defaultRouting[index].pgPercentage.hasOwnProperty(
                            'axisnb'
                        ) && (
                            <li className="percent-option">
                                <span>Axis NB</span>
                                <Field
                                    name={`${member}.pgPercentage.axisnb`}
                                    id={`${member}-pgPercentage-axisnb`}
                                    type="number"
                                    component={FormElems.Input}
                                    placeholder="%"
                                    min="0"
                                    max="100"
                                    postfixContent="%"
                                    disabled={isViewMode}
                                />
                            </li>
                        )}
                        {defaultRouting[index].pgPercentage.hasOwnProperty(
                            'wibmo'
                        ) && (
                            <li className="percent-option">
                                <span>Wibmo</span>
                                <Field
                                    name={`${member}.pgPercentage.wibmo`}
                                    id={`${member}-pgPercentage-wibmo`}
                                    type="number"
                                    component={FormElems.Input}
                                    placeholder="%"
                                    min="0"
                                    max="100"
                                    postfixContent="%"
                                    disabled={isViewMode}
                                />
                            </li>
                        )}
                    </ul>
                </td>
            </tr>
        ))}
    </>
);

RoutingTab.propTypes = {
    data: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func,
    history: PropTypes.object,
    auth: PropTypes.object,
    nextPath: PropTypes.string,
    previousPath: PropTypes.string,
    merchantData: PropTypes.object,
    actions: PropTypes.object,
    sectionType: PropTypes.string,
    name: PropTypes.string,
    formData: PropTypes.object,
    isEditMode: PropTypes.bool,
    isViewMode: PropTypes.bool,
    editData: PropTypes.object,
    onBoardSteps: PropTypes.array,
    isInEditMode: PropTypes.bool,
    dirty: PropTypes.bool,
};

renderRoutingRows.propTypes = {
    fields: PropTypes.array,
    meta: PropTypes.object,
    defaultRouting: PropTypes.object,
};

const mapStateToProps = ({ auth, form, merchantData, editData }) => ({
    auth,
    formData: form['routing-form'],
    merchantData,
    editData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            hideLoader,
            showLoader,
            fetchDefaultRoutingRequest,
            fetchRouterDetailsRequest,
            saveAndContinueRequest,
            resetSaveDataSuccessKey,
            updateRoutingDataRequest,
            addMerchantStepUpdateMakerRequest,
            resetUpdateDataSuccessKey,
        },
        dispatch
    ),
});

export default withRouter(
    compose(
        reduxForm({
            form: 'routing-form',
            validate,
            enableReinitialize: true,
        }),
        connect(mapStateToProps, mapDispatchToProps)
    )(RoutingTab)
);
